import React, { useMemo } from 'react';

import { Badge } from '@/components/global/Badge';
import { ProgressBarCircle } from '@/components/global/ProgressBarCircle';

import { TRecommendation } from '@/services/requests/Recommendation/types/template4';

type TProps = {
  data: TRecommendation;
};

export function Score({ data }: TProps) {
  const { image, current_task, total_tasks, tasks_text, tasks_bonus } =
    data.detail;

  const badgeText = useMemo(() => {
    return `${current_task} / ${total_tasks}`;
  }, [current_task, total_tasks]);

  const progressBarValue = useMemo(() => {
    return Math.floor(
      (parseInt(current_task, 10) / parseInt(total_tasks, 10)) * 100,
    );
  }, [current_task, total_tasks]);

  return (
    <div className="vitrine-template4__score">
      <span className="vitrine-template4__score-icon">
        <img src={image.url} alt="Andamento da pontuação" />
        <ProgressBarCircle value={progressBarValue} />
      </span>
      <span className="vitrine-template4__score-content">
        <span className="vitrine-template4__score-content-badge">
          <Badge text={badgeText} /> <strong>{tasks_text}</strong>
        </span>
        <span>{tasks_bonus}</span>
      </span>
    </div>
  );
}
